import React from "react";
import { connect } from "react-redux";
import { BaseComponent } from "BaseComponent";
import Button from "react-bootstrap-button-loader";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import {
  fetchCatgoryList,
  updateEventGuideCategoryList,
  openEventGuideModal,
  getMaxDisplayorder,
  fetchEventGuideList,
} from "ActionsEventguide";
import { showError, showSuccess } from "ReduxErrorBar";
import ContentIcon, { HEADING_ABOUT } from "ContentIcon";
import NoContent, { NO_EVENTGUIDE } from "NoContent";
import { screenHeightLeftFromTop } from "Constants";
import EventGuideCategoryItem from "./eventguide-category-list-item";
import EditEventGuide from "./editeventguide";
import LocaleStrings from "Languages";
import Loader from "Loader";

const DragHandle = sortableHandle(({ sectionname }) => (
  <div
    className="col-md-12 DraggedStuff"
    style={{ paddingLeft: 4, cursor: "move" }}
  >
    <div className="vcenter ">
      <i className="fa fa-bars mx-6" aria-hidden="true"></i>
      <span className="content-subheading-title">{sectionname}</span>
    </div>
  </div>
));

const SortableSection = SortableElement(
  ({ value, pageDataLength, currentPage, finishOperationsCallback }) => (
    <div>
      <DragHandle sectionname={value.category} />
      <EventGuideCategoryItem
        key={value.displaycategoryorder}
        category={value}
        pageDataLength={pageDataLength}
        currentPage={currentPage}
        finishOperationsCallback={finishOperationsCallback}
        style={{ zIndex: 10000 }}
      />
    </div>
  )
);

const SortableSectionList = SortableContainer(
  ({
    collection,
    pageDataLength,
    currentPage,
    disabled,
    finishOperationsCallback,
  }) => {
    return (
      <div>
        {collection.map((value, index) => {
          return (
            <SortableSection
              key={`section-${index}`}
              index={index}
              value={value}
              pageDataLength={pageDataLength}
              currentPage={currentPage}
              disabled={disabled}
              finishOperationsCallback={finishOperationsCallback}
            />
          );
        })}
      </div>
    );
  }
);

class About extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      Loader: false,
      pageLoader: false, // Table content loading
      desc: LocaleStrings.content_text_preparing_eventguide,
      pageNumber: 1,
    };
  }

  // When Component Mount
  componentDidMount() {
    this.setState({ loading: true });

    // Call For Event Guide List
    this.props.fetchCatgoryList(this.props.session, (CallBackResponse) => {
      this.setState({ loading: false });
    });

    this.props.getMaxDisplayorder(this.props.session, (CallBackResponse) => {});
  }

  open() {
    // this.props.reset();
    this.props.openEventGuideModal({ ...this.state, showModal: true });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    var arrAvailable = this.props.categoryList.data;

    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex); // Old list

    var newArrAvailable = []; // New array

    this.setState({ activeCount: arrAvailable.length });

    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, displaycategoryorder: index + 1 });
    });

    this.setState({ pageLoader: true });
    this.props.updateEventGuideCategoryList(
      this.props.session,
      newArrAvailable,
      (res) => {
        if (res.success) {
          this.setState({ pageLoader: false });
        } else {
          // console.log("Error.");
        }
      }
    );
  };

  additionCallback = (callContent = true) => {
    // after update call this method. it will display as your current record
    this.props.fetchCatgoryList(this.props.session, () => {});
    this.props.fetchEventGuideList(this.props.session, () => {});
    if (callContent == true) {
      this.callContentBoardStatus();
    }
  };

  callContentBoardStatus = () => {
    this.props.contentBoardStatus();
  };

  render() {
    let { deviceSize, modalData } = this.props;
    let { pageNumber, pageLoader } = this.state;
    let categoryList = this.props.categoryList.data;
    var classCustom = "";

    if (pageLoader) {
      classCustom = "gamification-page-loading";
    }

    let pageDataLength =
      this.props.categoryList && this.props.categoryList.data
        ? this.props.categoryList.data.length
        : 0;

    return (
      <div>
        {/* Header */}
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_ABOUT} />
          </div>
          <div className="pull-right h-100 vertical-align-center content-end">
            <Button
              className="btn-custom-blue schedule-add-button"
              bsStyle=""
              onClick={this.open.bind(this)}
            >
              <img
                style={{ paddingRight: 10, paddingBottom: 3 }}
                src="../../style/images/header-icons/plus.png"
              ></img>
              {LocaleStrings.button_add_new}
            </Button>
          </div>
        </div>
        <div className="clearfix"></div>

        {/* Panel Body */}
        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : categoryList && categoryList.length > 0 ? (
            <div>
              <div
                className={`px-15 col-md-12 ${classCustom}`}
                style={{
                  backgroundColor: "#ffffff",
                  backfaceVisibility: "hidden",
                  willChange: "transform",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                  titleBarStyle: "hidden",
                }}
              >
                <SortableSectionList
                  useDragHandle
                  collection={this.props.categoryList.data}
                  onSortEnd={this.onSortEnd}
                  //pressDelay={200}
                  axis="y"
                  lockAxis="y"
                  pageDataLength={pageDataLength}
                  currentPage={pageNumber}
                  finishOperationsCallback={this.additionCallback}
                />
              </div>
            </div>
          ) : (
            <NoContent contentType={NO_EVENTGUIDE} />
          )}
        </div>

        {modalData.showModal === true ? (
          <EditEventGuide
            history={this.props.history}
            finishOperationsCallback={this.additionCallback}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  // debugger;
  var { session, user } = state;
  return {
    session,
    deviceSize: state.deviceSize,
    categoryList: state.categoryList,
    modalData: state.eventguideModel,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchCatgoryList,
  updateEventGuideCategoryList,
  openEventGuideModal,
  getMaxDisplayorder,
  fetchEventGuideList,
})(About);
